
<div class="list">
  <div class="d__flex header">
    <!-- <h6 class="m-0 heading">Centre Selection</h6> -->
    <div>
      <h6 class="m-0 heading__">Select a centre</h6>
      <p class="m-0 small_name gray_cr">Here , You have to assign some centre for your catalogue products</p>
    </div>
    <ion-icon (click)="close_modal()" class="mouse" name="close-outline"></ion-icon>
  </div>

  <div class="box_sec">
    <div [class.active]="item['isActive']" (click)="(type && type == 'filters') ? add(item) : add_warehous(item)" *ngFor="let item of warehouse_list" class="d__flex mouse boxs">
      <h6 class="m-0 name_">{{item.label}}</h6>
      <ion-icon name="checkmark-circle-outline"></ion-icon>
    </div>
  </div>

  <div  *ngIf="!type" class="buttons_div">
    <!-- <ion-button class="close_btn" (click)="close_modal()" fill="clear">Close</ion-button> -->
    <ion-button class="close_btn" (click)="select_all(warehouse_list)" fill="clear">Add All</ion-button>
    <ion-button (click)="save()" fill="clear">Proceed</ion-button>
  </div>

</div>